import { mergeClasses } from '../utils/mergeClasses';
import { Logo } from './Logo';

export function Footer() {
  return (
    <div
      className={mergeClasses(
        'footer',
        'flex flex-col gap-4 p-10',
        'w-full bg-inpay-gray-primary-200 dark:bg-inpay-green-primary-mixes-20%-black',
        'text-inpay-green-primary-1000'
      )}
    >
      <div className="flex flex-row justify-between">
        <a href="/">
          <Logo className="w-28 text-inpay-green-primary-1000 dark:text-white" />
        </a>
      </div>
      <div className="flex flex-row flex-wrap justify-between gap-2 text-sm text-inpay-dark-green-1000 dark:text-white lg:flex-nowrap">
        <div className="flex flex-row flex-wrap gap-4">
          <span className="dark:text-white">
            © 2024 Inpay. All rights reserved.
          </span>
          <ol className="flex grow flex-row flex-wrap gap-4 whitespace-nowrap font-semibold">
            <li>
              <a id="customer-app-link" href={window.location.origin}>
                Customer App
              </a>
            </li>
            <li>
              <a href="https://www.inpay.com/about-us/">About Us</a>
            </li>
            <li>
              <a href="https://www.inpay.com/contact-us/">Contact Us</a>
            </li>
            <li>
              <a href="https://www.inpay.com/privacy-policy/">Privacy Policy</a>
            </li>
          </ol>
        </div>
        <div className="text-right dark:text-white">
          Need assistance? Please contact our team at{' '}
          <a
            href="mailto:support@inpay.com"
            className="font-semibold text-inpay-green-primary-1000 dark:text-inpay-green-secondary-light-1000"
          >
            support@inpay.com
          </a>
        </div>
      </div>
    </div>
  );
}
